/* Úvodní „wow" loader (jen homepage) – logo reveal → redbar → wipe → hero stagger.
   Přeneseno 1:1 z _template/index.html. GSAP je ve vendor.js (window.gsap). */
(function () {
	var de = document.documentElement;
	var loader = document.getElementById('loader');
	if (!loader || !de.classList.contains('js-loading')) return;

	function cssFallback() {
		clearTimeout(window.__loaderFailsafe);
		de.classList.add('loader-fallback');
		setTimeout(function () {
			de.classList.remove('js-loading');
			de.classList.remove('loader-fallback');
			if (loader.parentNode) loader.remove();
		}, 400);
	}

	// GSAP nedostupný → CSS fade fallback
	if (!window.gsap) { cssFallback(); return; }
	// Reduced motion → jen fade
	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { cssFallback(); return; }

	var started = false;
	function start() {
		if (started) return;
		started = true;
		if (de.classList.contains('loader-fallback') || !loader.parentNode) return;
		clearTimeout(window.__loaderFailsafe);

		var gsap = window.gsap;
		var logo = loader.querySelector('.loader-inner img');
		var inner = loader.querySelector('.loader-inner');
		var bar = loader.querySelector('.loader-bar i');
		var bgImgs = loader.querySelectorAll('.loader-bg img');
		var robert = loader.querySelector('.loader-robert');
		var heroEls = document.querySelectorAll('[data-hero]:not([data-hero="photo"])');
		var photo = document.querySelector('[data-hero="photo"]');

		gsap.set(logo, { y: 24 });
		if (bgImgs.length) gsap.set(bgImgs, { scale: 1.06 });

		var tl = gsap.timeline({
			defaults: { ease: 'expo.out' },
			onComplete: function () {
				de.classList.remove('js-loading');
				if (heroEls.length) gsap.set(heroEls, { clearProps: 'transform,opacity,visibility' });
				if (photo) gsap.set(photo, { clearProps: 'transform,opacity,visibility' });
				loader.remove();
			}
		});

		if (bgImgs.length) {
			tl.to(bgImgs, { scale: 1, duration: 4.6, ease: 'none' }, 0)
				.to(bgImgs[0], { opacity: .1, duration: .7 }, 0)
				.to(bgImgs[0], { opacity: 0, duration: .7 }, 1.6);
			if (bgImgs[1]) tl.to(bgImgs[1], { opacity: .1, duration: .7 }, 1.6).to(bgImgs[1], { opacity: 0, duration: .7 }, 3.1);
			if (bgImgs[2]) tl.to(bgImgs[2], { opacity: .1, duration: .7 }, 3.1);
		}
		if (robert) tl.fromTo(robert, { y: 70, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 1.6 }, 0.2);
		tl.to(logo, { clipPath: 'inset(0 0% 0 0)', opacity: 1, y: 0, duration: 1.0 }, 0.3)
			.to(bar, { scaleX: 1, duration: 1.0, ease: 'power4.inOut' }, 1.2)
			.to(loader, { yPercent: -100, duration: 0.6, ease: 'power4.inOut' }, 3.4)
			.to(inner, { yPercent: -60, duration: 0.6, ease: 'power4.inOut' }, 3.4);
		if (robert) tl.to(robert, { yPercent: -25, duration: 0.6, ease: 'power4.inOut' }, 3.4);
		if (heroEls.length) tl.fromTo(heroEls, { y: 28, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 0.9, stagger: 0.1 }, 3.6);
		if (photo) tl.fromTo(photo, { autoAlpha: 0, scale: 1.04 }, { autoAlpha: 1, scale: 1, duration: 1.1 }, 3.9);

		window.__loaderTl = tl;
	}

	if (document.readyState === 'complete') start();
	else window.addEventListener('load', start);
	setTimeout(start, 1800);
})();
